import { IArrayValidation } from "@generation/core";
import { translate } from "../Locales/translator";

export class ArrayItemsRequiredValidation implements IArrayValidation {
  key = "required";
  constructor(public readonly dependsOn: boolean = false) {}

  validate = (data: unknown[]) => {
    return data.length >= 1;
  };

  message = (label: string): string => translate("Generation_Form_MinimaalEen{label}IsVerplicht", { label: label });
}
